export default function PrivacyPolicy() {
  return (
    <main className="min-h-screen bg-slate-50 text-slate-900 px-4 py-12">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-6 mt-5">Privacy Policy</h1>

        <p className="text-slate-600 leading-relaxed mb-6">
          This Privacy Policy describes how LeadOnLeads collects, uses, stores, and shares personal information when you visit or use our website and services.
        </p>

        <section className="space-y-6 text-slate-700">
          <div>
            <h2 className="text-xl font-semibold mb-2">Information We Collect</h2>
            <p className="mb-2">
              We collect information you provide directly, such as contact details, account information, and messages submitted through forms. We also collect usage data automatically when you interact with our site, including device, browser, IP address, and page activity.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">How We Use Your Information</h2>
            <p className="mb-2">
              We use data to deliver and improve our services, personalize your experience, respond to inquiries, and communicate updates. We may also use information for analytics and security purposes.
            </p>
          </div>

          {/* <div>
            <h2 className="text-xl font-semibold mb-2">Cookies and Tracking</h2>
            <p className="mb-2">
              We use cookies and similar tracking technologies to remember preferences, understand usage patterns, and improve site performance. You can manage cookie settings through your browser.
            </p>
          </div> */}

          <div>
            <h2 className="text-xl font-semibold mb-2">Sharing and Disclosure</h2>
            <p className="mb-2">
              We do not sell your personal data. We may share information with service providers who help us operate the site, comply with legal obligations, or protect our rights.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">Data Security</h2>
            <p className="mb-2">
              We implement reasonable technical and organizational measures to protect data from unauthorized access, use, or disclosure.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">Your Rights</h2>
            <p className="mb-2">
              Depending on your location, you may have rights to access, correct, or delete personal information. Contact us at contact@leadonleads.com for privacy inquiries.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">Changes to This Policy</h2>
            <p className="mb-2">
              We may update this Privacy Policy from time to time. The date at the top indicates when it was last revised. Continued use of the site after changes indicates acceptance of the updated policy.
            </p>
          </div>
        </section>
      </div>
    </main>
  );
}
